import {
  RosterLevelEnum,
  type RosterLevelType,
} from '@wwe-portal/entities/roster.type';
import { levelEnumToLabel } from '../roster/level';

export const isRosterLevel = (level: unknown): level is RosterLevelType => {
  return typeof level === 'string' && level in RosterLevelEnum;
};

export const isRosterOfferItem = (itemId: string) => {
  const regex = /^Poster_\d{2,}[GSB]$/;
  return regex.test(itemId);
};

export const parseRosterOfferItemStats = (item: {
  description: string | undefined;
  text: string | undefined;
  itemId: string | undefined;
}) => {
  if (!item.itemId || !isRosterOfferItem(item.itemId)) return null;

  const slug = item.itemId.split(':')[0]?.slice(-2);
  const rate = parseInt(slug?.[0] ?? '', 0);
  const level = slug?.[1] ?? null;

  if (
    !isRosterLevel(level) ||
    slug == null ||
    isNaN(rate) ||
    rate < 1 ||
    rate > 6
  )
    return null;

  return {
    rate,
    level,
  };
};

export const parseOfferItemDescription = (item: {
  description: string | undefined;
  text: string | undefined;
  stats: {
    rate: number;
    level: RosterLevelType;
  } | null;
}) => {
  const baseDescription = item.description ?? item.text ?? '';
  if (!item.stats) return baseDescription;
  return `${baseDescription} ${item.stats.rate} Star ${levelEnumToLabel[item.stats.level]}`;
};
